export interface LocationEntryModel {
    id: string;
    locationType: LocationType | string;
    name: string;
    description: string;
    url: string;
    handleParkingOpeningStart: boolean;
    handleCargoLoadingStart: boolean;
}

export interface NewLocationEntryModel {
    apiKey: string;
    locationType: LocationType | string;
    name: string;
    description: string;
    url: string;
    handleParkingOpeningStart: boolean;
    handleCargoLoadingStart: boolean;
}

export interface LocationDropDownEntryModel {
    id: string;
    name: string;
    locationType: LocationType;
}

export enum LocationType {
    PHOTOSHOOTER = "PHOTOSHOOTER",
    ENTRY_TERMINAL = "ENTRY_TERMINAL",
    EXIT_TERMINAL = "EXIT_TERMINAL",
    LIGHTBOARD = "LIGHTBOARD",
    NO_AUTOMATION = "NO_AUTOMATION",
    PARKING = "PARKING",
    WHARF = "WHARF"
}